import { useState, useEffect, useCallback } from 'react';

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const storedValue = window.localStorage.getItem(key);
      return storedValue === null ? defaultValue : JSON.parse(storedValue);
    } catch (error) {
      console.error(`Error reading localStorage key “${key}”:`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    const listener = (e) => {
      if (e.storageArea === window.localStorage && e.key === key) {
        try {
          setValue(JSON.parse(e.newValue));
        } catch (error) {
          console.error(`Error parsing new value for localStorage key “${key}”:`, error);
        }
      }
    };
    window.addEventListener('storage', listener);
    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [key]);

  const setValueInLocalStorage = useCallback(
    (newValue) => {
      setValue((currentValue) => {
        const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
        try {
          window.localStorage.setItem(key, JSON.stringify(result));
        } catch (error) {
          console.error(`Error setting localStorage key “${key}”:`, error);
        }
        return result;
      });
    },
    [key]
  );

  return [value, setValueInLocalStorage];
}
